import React, { createContext, useContext, useState, ReactNode } from "react";

interface Reaction {
  id?: number;
  firstName?: string;
  lastName?: string;
  preferredName?: string;
  email?: string;
  reaction?: string;
}

export interface ModalData {
  commentId?: number;
  postId?: number;
  userId?: number;
  reactions?: Reaction[];
}

interface CommentLikeModalContextType {
  isOpen: boolean;
  data: ModalData | null;
  openModal: (data: ModalData) => void;
  closeModal: () => void;
  setData: React.Dispatch<React.SetStateAction<ModalData | null>>;
}

const CommentLikeModalContext = createContext<
  CommentLikeModalContextType | undefined
>(undefined);

export const CommentLikeModalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<ModalData | null>(null);

  const openModal = (modalData: ModalData) => {
    setData(modalData);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setData(null);
  };

  return (
    <CommentLikeModalContext.Provider
      value={{
        isOpen,
        data,
        openModal,
        closeModal,
        setData,
      }}
    >
      {children}
    </CommentLikeModalContext.Provider>
  );
};

export const useCommentLikeModal = () => {
  const context = useContext(CommentLikeModalContext);
  if (context === undefined) {
    throw new Error(
      "useCommentLikeModal must be used within a CommentLikeModalProvider",
    );
  }
  return context;
};
